import Hero from "@/components/landing/contact/Hero";
import Header from "@/components/landing/layout/Header";
import About from "@/components/landing/contact/About";
import Cards from "@/components/landing/contact/cards";
import Footer from "@/components/landing/layout/Footer";

const ContactUs = () => {
  return (
    <div>
      <Header />
      <Hero />
      <section className="tw-my-12 tw-z-10 tw-relative sm:tw-my-16 md:tw-my-24 ">
        <Cards />
        
      </section>
      <section className="tw-my-12 sm:tw-my-16 md:tw-my-24 ">
        <About />
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;
